export const COMMON_UPLOAD_FILE_BEGIN = 'COMMON_UPLOAD_FILE_BEGIN';
export const COMMON_UPLOAD_FILE_SUCCESS = 'COMMON_UPLOAD_FILE_SUCCESS';
export const COMMON_UPLOAD_FILE_FAILURE = 'COMMON_UPLOAD_FILE_FAILURE';
export const COMMON_UPLOAD_FILE_DISMISS_ERROR = 'COMMON_UPLOAD_FILE_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/common/redux/constants.js